
import React from 'react';
import { generateSitemapIndex } from '@/lib/sitemap/utils';
import { 
  generateMainSitemap, 
  generateNursingHomesSitemap, 
  generateCountiesSitemap,
  generateGuidesAndBlogSitemap 
} from '@/lib/sitemap/generators';

const SITE_URL = 'https://www.grandpal.co';

/**
 * Handles sitemap requests and returns the appropriate XML content
 */
export async function handleSitemapRequest(path: string): Promise<Response | null> {
  // Only handle sitemap paths
  if (!path.includes('/sitemap.xml') && !path.includes('/sitemaps/')) {
    return null;
  }

  console.log(`Sitemap middleware handling: ${path}`);
  
  try {
    let content: string;

    // Route to the appropriate sitemap generator
    if (path === '/sitemap.xml' || path === '/sitemap.xml/') {
      content = generateSitemapIndex(SITE_URL);
    } else if (path === '/sitemaps/main.xml' || path === '/sitemaps/main.xml/') {
      content = generateMainSitemap();
    } else if (path === '/sitemaps/nursing-homes.xml' || path === '/sitemaps/nursing-homes.xml/') {
      content = await generateNursingHomesSitemap();
    } else if (path === '/sitemaps/counties.xml' || path === '/sitemaps/counties.xml/') {
      content = await generateCountiesSitemap();
    } else if (path === '/sitemaps/content.xml' || path === '/sitemaps/content.xml/') {
      content = await generateGuidesAndBlogSitemap();
    } else {
      // Default to index for unknown paths
      content = generateSitemapIndex(SITE_URL);
    }

    // Return response with appropriate headers
    return new Response(content, {
      headers: {
        'Content-Type': 'application/xml',
        'Cache-Control': 'public, max-age=3600'
      }
    });
  } catch (error: any) {
    console.error('Error in sitemap middleware:', error);
    return new Response(`<?xml version="1.0" encoding="UTF-8"?><error>${error.message}</error>`, {
      status: 500,
      headers: {
        'Content-Type': 'application/xml'
      }
    });
  }
}
